import { API } from "@/lib/api";

/**
 * Resolve image URL. If relative (/api/uploads/...), prepend backend URL.
 * If absolute http(s), return as-is.
 */
export function imgUrl(url) {
  if (!url) return "";
  if (url.startsWith("/api/")) {
    const base = API.replace(/\/api$/, "");
    return base + url;
  }
  return url;
}
